/* eslint-disable arrow-body-style */
import _ from 'underscore';
import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import {
  Image,
  Button,
  mergeClasses,
} from '@fluentui/react-components';
import { Dismiss20Regular } from '@fluentui/react-icons';

import { useStyles } from './style';

export const ImagePreviewView = ({
  imageView,
  url,
  buttonsConfig,
  buttonsRef,
  notificationConfig,
}) => {
  const classes = useStyles();

  const buttonNum = buttonsConfig.length;

  const buttonItem = useCallback(({ config, index, key }) => {
    const {
      onClick,
      icon: Icon,
      disabled,
      text,
    } = config;

    const isFirstButton = index === 0;
    const isLastButton = index === buttonNum - 1;

    return (
      <Button
        key={`${key}-${index}`}
        className={mergeClasses('button-item', isFirstButton ? 'first-button-item' : '', isLastButton ? 'last-button-item' : '')}
        onClick={onClick}
        icon={<Icon />}
        disabled={disabled}
        shape="square"
      >
        {text}
      </Button>
    );
  }, [buttonNum]);

  const notificationContent = useMemo(() => {
    const {
      icon,
      content,
      onDismiss,
      dismissAriaLabel,
    } = notificationConfig || {};

    return (
      <div className="image-preview-notification-wrapper">
        {icon}
        {content}
        {
          _.isFunction(onDismiss) &&
          <Button
            icon={<Dismiss20Regular />}
            appearance="subtle"
            onClick={onDismiss}
            aria-label={dismissAriaLabel}
          />
        }
      </div>
    );
  }, [notificationConfig]);

  return (
    <div className={mergeClasses(classes.imagePreviewView, 'image-preview-view')}>
      {
        buttonNum > 0 &&
        <div className="image-preview-button-wrapper" ref={buttonsRef}>
          {
            buttonsConfig.map((config, index) => (
              buttonItem({ config, index, key: 'image-preview-button' })
            ))
          }
        </div>
      }
      <div className="image-preview-image-wrapper">
        {
          imageView ||
          <Image
            className="image-item"
            src={url}
            alt="image preview"
          />
        }
      </div>
      {
        notificationConfig && notificationContent
      }
    </div>
  );
};

ImagePreviewView.propTypes = {
  imageView: PropTypes.shape({}),
  url: PropTypes.string,
  buttonsConfig: PropTypes.arrayOf(PropTypes.shape({})),
  buttonsRef: PropTypes.shape({}),
  notificationConfig: PropTypes.shape({}),
};

ImagePreviewView.defaultProps = {
  imageView: undefined,
  url: undefined,
  buttonsConfig: [],
  buttonsRef: undefined,
  notificationConfig: undefined,
};
